// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__532wi","title":"styles_title__XDFYj","subtitle":"styles_subtitle__0KjGH","form":"styles_form__dgSuZ","submit":"styles_submit___MuHx"};